export const obfuscateEmail = (email: string): string => {
  const atIndex = email.indexOf("@");
  const prefix = email.substring(0, 4);
  const maskedPart = "*".repeat(atIndex - 4);
  const domain = email.substring(atIndex);
  return `${prefix}${maskedPart}${domain}`.replace(/['"]/g, "");
};
